export default {
  // Page title
  'adsReport.title': 'Reporte de datos y análisis',
  'adsReport.agentAccount': 'Nombre del Agente',

  // Search fields
  'adsReport.agentName': 'Nombre del agente',
  'adsReport.adsPlatform': 'Plataforma de atribución',
  'adsReport.adsName': 'Nombre de atribución',
  'adsReport.eventName': 'Evento de atribución',
  'adsReport.dateRange': 'Rango de fechas',

  // Buttons
  'adsReport.search': 'Buscar',
  'adsReport.reset': 'Restablecer',
  'adsReport.export': 'Exportar',

  // Table columns
  'adsReport.serial': 'Serie',
  'adsReport.date': 'Fecha',
  'adsReport.uploadCount': 'Cantidad de cargas',
  'adsReport.successCount': 'Cantidad de éxitos',

  // Messages
  'adsReport.fetchDataFailed': 'Error al obtener datos',
  'adsReport.noData': 'Sin datos',
  'adsReport.exportSuccess': 'Tarea de exportación enviada, consulte la lista de descargas',
  'adsReport.exportFailed': 'Error al exportar',

  // Pagination
  'adsReport.totalRecords': 'Total {total} registros',
  'adsReport.pagination': 'Página {current} de {page}, Total {total} registros',
};
